import { TournamentState } from '@ps/web-poker-tile-mappers';
import { StarsButton } from '@ps/web-shared-components';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CSSTransition } from 'react-transition-group';

import type { RootState } from '@swf/core/store';

import { useHomeGamesWidget } from '../../../model';
import type { HGPokerGameTile } from '../../../types/common';
import TickIcon from '../assets/tick.svg';

import { TXTCLI_Register__toTournament, TXTCLI_Registered } from './RegisterButton.messages.json';
import {
  button,
  buttonEnter,
  buttonEnterActive,
  buttonExit,
  buttonExitActive
} from './RegisterButton.scss';

interface AttributeProps {
  id: HGPokerGameTile['id'];
  tournamentState: HGPokerGameTile['tournamentState'];
}

export const transition = {
  enter: buttonEnter,
  enterActive: buttonEnterActive,
  exit: buttonExit,
  exitActive: buttonExitActive
};

const RegisterButton: React.FC<AttributeProps> = ({ id, tournamentState }) => {
  const { widgetSelect } = useHomeGamesWidget();
  const param = useMemo(
    () => ({
      id,
      tournamentState: tournamentState || TournamentState.CANCELLED
    }),
    [id, tournamentState]
  );
  const { show, eligible, registered } = useSelector((rootState: RootState) =>
    widgetSelect.getTournamentRegistrationStatus(rootState, param)
  );
  const translation = registered ? TXTCLI_Registered : TXTCLI_Register__toTournament;

  return (
    <CSSTransition
      in={(show && eligible) || (show && registered)}
      classNames={transition}
      timeout={200}
      unmountOnExit
    >
      <StarsButton
        className={button}
        iconPosition="after"
        translation={translation}
        icon={registered ? <TickIcon /> : undefined}
      />
    </CSSTransition>
  );
};
export default RegisterButton;
